<template>
  <div>
    <modal-confirm
      body="Êtes-vous sûr de vouloir désactiver le profil"
      v-if="!sameUser"
      :title="title"
      :data="data"
      @close="close"
      @confirm="confirm">
    </modal-confirm>

    <modal-confirm
      v-if="sameUser"
      body="Vous ne pouvez pas désactiver votre propre compte"
      :title="title"
      :data="data"
      @close="close"
      only-close="true">
    </modal-confirm>


  </div>
</template>

<script>
  import ModalConfirm from '../modals/ModalConfirm.vue'

  export default {
    components: {
      ModalConfirm,
    },
    computed: {
      sameUser () {
        console.log("this.data ::: " , this.data)
        console.log("logged in ::: " , this.$store.state.login.idUser)
        if (this.data) {
          return this.$store.state.login.idUser === this.data.id
        }
        return false
      },
    },
    methods: {
      close: function () {
        this.$emit('close')
      },
      confirm: function () {
        this.$emit('confirm')
      },
    },
    props: [
      'title',
      'body',
      'data',
    ],
  }
</script>



// WEBPACK FOOTER //
// DeactivationModal.vue?4fc76e6e